module.exports = __webpack_public_path__ + "img/people.e73b0816.png";